












































































































import {Component, Emit, Prop, Vue, Watch} from "vue-property-decorator";
import {STreeItem} from '@/components/dto/STreeItem';
import {SPropTypeEnum} from "@/components/dto/SPropTypeEnum";
import {TreeUtils} from "@/components/utils/TreeUtils";
import TreePropInput from "@/components/TreePropInput.vue";
import TreePropInputValue from "@/components/TreePropInputValue.vue";
import {v4 as uuid_v4} from "uuid";
import {RTreeServices, RTreeServicesImpl} from "@/services/RTreeServices";

@Component({
  components: {TreePropInputValue, TreePropInput},
  name: 'TreeItem',
})
    export default class TreeItem extends Vue {
        @Prop() item!: STreeItem;
        @Prop() inputPlainText!: boolean;
        @Prop() copyPaste!: boolean;
        @Prop({default: false}) readonly!: boolean;
        @Prop() isLastItem!: boolean;
        @Prop() isGenerateAllItems!: boolean;
        private isFolder: boolean = false;
        private isPencilHover: boolean = false;
        private isTrashHover: boolean = false;
        private isCopyHover: boolean = false;
        private isPasteHover: boolean = false;
        private isPlusHover: boolean = false;
        private isFolderHover: boolean = false;
        private modelOpen: boolean = false;
        private propOutputTypeString: SPropTypeEnum = SPropTypeEnum.SSTRING;
        private isOpenAllChild: boolean = false;
        private editPropName: boolean = false;
        private editPropValue: boolean = false;
        private treeService: RTreeServices = new RTreeServicesImpl();
        private lazyLoandingChildren: boolean = false;
        private displaySpinner: boolean = false;
        private refreshPopover: number = 0;

        constructor(){
          super();
            this.isFolder = this.folder();
            this.modelOpen = this.item.isOpen;
            if(this.item.propChildren.length >0){
              this.item.propChildren[this.item.propChildren.length -1].isLastItem = true;
              this.item.propChildren[this.item.propChildren.length -1].isLastEditItem = true;
            }
            if(!this.readonly) {
              document.addEventListener('scroll', this.refreshItem);
              document.addEventListener('click', this.refreshItem);
            }else {
              this.lazyLoandingChildren = true;
            }
          if(this.lazyLoandingChildren) {
            this.item.userViewed = true;
            this.refreshPopover +=1;
          }
        }
        updated(){
          if(!this.item.userViewed) {
            this.refreshItem();
            if(this.lazyLoandingChildren) {
              this.item.userViewed = true;
              this.refreshPopover +=1;
            }
          }
        }
        mounted(){
          if(this.item.isOpen) {
            this.refreshItem();
          }else{
            this.item.userViewed = false;
            this.refreshItem();
          }
          if(this.item.allGenerated && this.readonly){
            this.lazyLoandingChildren = true;
          }else {
            this.item.userViewed = false;
            this.refreshItem();
          }
          if(this.lazyLoandingChildren) {
            this.item.userViewed = true;
            this.refreshPopover +=1;
          }
        }

        get refreshPopoverKey(){
          return `refreshPopoverKey-${this.refreshPopover}`;
        }
        refreshItem(){
          if(!this.item.userViewed && !this.readonly) {
            this.lazyLoandingChildren = this.isInViewport(document.querySelector(`#lazyItem-${this.item.itemId}`));
          }
        }

        isInViewport(el: HTMLElement | null) {
          if(el === null) return false;
          const rect = el.getBoundingClientRect();
          return (
              rect.left >= 0 &&
              rect.bottom - 1000 <= (window.innerHeight || document.documentElement.clientHeight) &&
              rect.right <= (window.innerWidth || document.documentElement.clientWidth)
          );
        }

        get findedItem(){
          return this.item.isFinded ? 'finded-item': '';
        }

        get collapseItem(){
          return ((this.item.isOpen && !this.readonly) || (this.item.allGenerated && this.readonly));
        }
        set collapseItem(val: boolean){}

        editablePropName(val: boolean){
          this.editPropName = val;
        }
        editablePropValue(val: boolean){
          this.editPropValue = val;
        }

        @Watch('isGenerateAllItems')
        watchIsGenerateAllItems(newValue: boolean){
          this.watchModelAllGenerated(newValue);
        }

        watchModelAllGenerated(newValue: boolean){
          this.item.allGenerated = newValue;
          this.treeService.updateAllChildrenGenerated(newValue, this.item.propChildren);
          this.treeService.updateParentGenerated(newValue, this);
          this.treeService.updateChildrenString(newValue, this.item.propChildren);
          this.treeService.updateParentValue(this);
          this.emitIsLastGenerated();
        }

        @Emit('is-last-generated')
        emitIsLastGenerated(){
          return;
        }

        isLastGenerated(){
          this.treeService.setLastGeneratedAllItems(this.item.propChildren, false);
          this.emitIsLastGenerated();
        }

        @Emit('open-children')
        openChildren(){
          this.isOpenAllChild = !this.isOpenAllChild;
          return {item: this.item, isOpen: this.isOpenAllChild};
        }

        @Watch( 'item.isOpen')
        watchisOpen(newValue: boolean){
          if(newValue || (this.item.allGenerated && this.readonly)){
            this.modelOpen = newValue;
          }else {
            this.modelOpen = false;
          }
       }

        @Watch( 'item.propValue')
        watchpropValue(newValue: any){
          this.item.propValue = newValue;
          this.treeService.updateParentValue(this.$parent);
        }

        @Watch( 'item.propType')
        watchpropType(newValue: SPropTypeEnum){
          this.item.propType = newValue;
          if(this.item.propType !== SPropTypeEnum.SOBJECT || SPropTypeEnum.SARRAY){
            this.item.propChildren = [];
            this.item.isFolder = false;
            this.item.isOpen = false;
            this.item.propOutputValue = this.item.propValue;
            this.item.propOutputType = newValue;
            this.item.itemId = uuid_v4();
            this.emitIsLastGenerated();
          }
          this.treeService.updateParentValue(this.$parent);
        }

        @Watch( 'item.propName')
        watchpropName(newValue: any){
          this.item.propName = newValue;
          this.treeService.updateParentValue(this.$parent);
        }

        get showIconPaste(){
          return this.item.toggleCopyPaste && (this.item.propType === SPropTypeEnum.SARRAY || this.item.propType === SPropTypeEnum.SOBJECT);
        }

        @Watch('item.propChildren')
        watchItemChildren(){
          this.folder();
          this.treeService.updateParentValue(this);
        }

        @Watch( 'item.propOutputType')
        watchpropOutputType(val: SPropTypeEnum){
          this.treeService.updateChildrenString(this.item.allGenerated, this.item.propChildren);
          this.treeService.updateParentValue(this);
        }
        folder(){
          let isJsonString: boolean = false;
          let parseData: any = null;
            try{
              if(this.item.propType === SPropTypeEnum.SSTRING){
                parseData = JSON.parse(this.item.propValue);
                isJsonString = true;
              }
            }catch (e){
              isJsonString = false;
            };
            if(isJsonString && this.item.propType !== SPropTypeEnum.SNULL){
              if(parseData === null && this.item.propOutputType === SPropTypeEnum.SSTRING){
               // nic sa nedeje
              }else {
                this.item.propType = TreeUtils.propValueType(parseData);
              }
              if(this.item.propType === SPropTypeEnum.SOBJECT){
                this.item.propOutputType = SPropTypeEnum.SSTRING;
              }
            }
            if((this.item.propType === SPropTypeEnum.SOBJECT && !this.emptyObject) ||
                (this.item.propType === SPropTypeEnum.SARRAY && !this.emptyArray)){
              this.item.isFolder = true;
              return true;
            }
            this.item.isFolder = false;
            return false;
        }

        get emptyObject(){
          return typeof this.item.propValue === 'string' ? this.item.propValue.replace(/\s/g, "") === '{}' : false;
        }

        get emptyArray(){
          return typeof this.item.propValue === 'string' ? this.item.propValue.replace(/\s/g, "") === '[]' : false;
        }

        get propIsOBJorARRAY(){
          return this.item.propType === SPropTypeEnum.SARRAY || this.item.propType === SPropTypeEnum.SOBJECT;
        }

        get propOutputIsString(){
          return this.item.propOutputType === SPropTypeEnum.SSTRING;
        }

        toggleItem(){
          if(this.isFolder && !this.readonly){
            this.item.isOpen = !this.item.isOpen;
          }
        }

        visibleIconPlus(propType: SPropTypeEnum){
          if(propType === SPropTypeEnum.SOBJECT || propType === SPropTypeEnum.SARRAY){
            return true;
          }
          return false;
        }

        iconPencilHover(hovered:boolean){
            this.isPencilHover = hovered;
        }
        get outputValue(){
          if(this.readonly && this.item.propOutputType === SPropTypeEnum.SSTRING && this.item.isFolder){
            return JSON.stringify(this.item.propOutputValue);
          }else if(this.readonly && this.item.propType === SPropTypeEnum.SSTRING){
            return JSON.stringify(this.item.propValue);
          }
          return this.item.propValue;
        }
        get outputName(){
          let returnName: any = this.item.propName;
          if(this.readonly){
            if(this.$parent.$parent.$props !== undefined &&
                this.$parent.$parent.$props.item &&
                this.$parent.$parent.$props.item.propOutputType === SPropTypeEnum.SARRAY &&
                (this.item.propOutputType === SPropTypeEnum.SOBJECT || this.item.propOutputType === SPropTypeEnum.SSTRING)){
              return '';
            }else {
              return `${JSON.stringify(returnName)}:`;
            }
          }
          return `${returnName}:`;
        }
        get iconPencilVariant(){
          return this.isPencilHover? 'primary' : 'secundary';
        }
        iconFolderHover(hovered:boolean){
          this.isFolderHover = hovered;
        }
        get iconFolderVariant(){
          return this.isFolderHover? 'primary' : 'secundary';
        }
        iconPlusHover(hovered:boolean){
          this.isPlusHover = hovered;
        }
        get iconPlusVariant(){
          return this.isPlusHover? 'primary' : 'secundary';
        }
        iconCopyHover(hovered:boolean){
          this.isCopyHover = hovered;
        }
        get iconCopyVariant(){
          return this.isCopyHover? 'primary' : 'secundary';
        }
        iconPasteHover(hovered:boolean){
          this.isPasteHover = hovered;
        }
        get iconPasteVariant(){
          return this.isPasteHover? 'primary' : 'secundary';
        }
        iconTrashHover(hovered:boolean){
          this.isTrashHover = hovered;
        }
        get iconTrashVariant(){
          return this.isTrashHover? 'primary' : 'secundary';
        }
    }
